var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.barcodePath && _vm.barcodePath.url)?_c('WechatBarcode',{attrs:{"path":_vm.barcodePath.url,"showText":_vm.barcodePath.showText}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }